// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div.faq__accordion-header[data-v-839193d4] {\n  pointer-events: all;\n}\n.accordion-enter-active[data-v-839193d4],\n.accordion-leave-active[data-v-839193d4] {\n  will-change: height, opacity;\n  transition: height 0.3s ease, opacity 0.3s ease;\n  overflow: hidden;\n}\n.accordion-enter[data-v-839193d4],\n.accordion-leave-to[data-v-839193d4] {\n  height: 0 !important;\n  opacity: 0;\n}\n.accordion__header[data-v-839193d4] {\n  display: flex;\n}", ""]);
// Exports
module.exports = exports;
